import { useState } from 'react';

import { useBreakpointDown } from '@nesso/ui/hooks/use-breakpoint-down';

import { ShareReferralLinkButton, ShareReferralLinkDialog } from '@/features/referral/share-link';

export function ShareReferralLinkTrigger() {
    const isMobile = useBreakpointDown('md');
    const [isOpen, setIsOpen] = useState(false);

    if (isMobile) return null;

    return (
        <>
            <ShareReferralLinkButton onClick={() => setIsOpen(true)} />
            <ShareReferralLinkDialog open={isOpen} onOpenChange={setIsOpen} />
        </>
    );
}
